export function getActionId(seed: string, searchId: string | undefined | null): string {
  return `${searchId || '0'}-${seed.replaceAll('-', '')}`.substring(0, 45);
}
